import { createMuiTheme } from '@material-ui/core/styles';
import { COLORS } from './styles/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
export const theme = createMuiTheme({
  props: {
    MuiCheckbox: {
      disableRipple: true,
      color: 'default',
      checkedIcon: (
        <div style={{
          border: '2px solid grey',
          backgroundColor: COLORS.white,
          borderRadius: 5,
          width: 20,
          height: 20
        }}>
          <FontAwesomeIcon
            icon={'check'}
            style={{
              position: 'absolute',
              fontSize: 14,
              top: 12,
              right: 12,
              color: COLORS.black
            }}
          />
        </div>

      ),
      icon: (
        <div style={{
          border: '2px solid grey',
          backgroundColor: COLORS.white,
          borderRadius: 5,
          width: 20,
          height: 20
        }}>
        </div>
      )
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global' : {

      }
    },
    MuiModal:{
      root:{
        display: 'flex'
      }
    },
    MuiTab : {
      root: {
        border: '1px solid ' + COLORS.grey,
        minHeight: 35
      }
    },
    MuiTabs: {
      root:{
        minHeight: 35
      },
      flexContainer: {
        justifyContent: 'center'
      }
    },
    MuiToggleButtonGroup:{
      root: {
        width:'100%',
        justifyContent: 'center'
      }
    },
    MuiToggleButton: {
      root: {
        '&:not(:last-child)': {
          borderRadius: 3,
          borderTopRightRadius: 3,
          borderBottomRightRadius: 3
        },
        '&:not(:first-child)':{
          borderLeft: '1px solid ' + COLORS.grey,
          borderRadius: 3,
          borderTopLeftRadius: 3,
          borderBottomLeftRadius: 3
        },
        '&:first-child':{
          marginRight: 15
        },
        border: '1px solid ' + COLORS.grey,
        height: 38
      }
    },
    MuiButton: {
      containedSecondary: {
        backgroundColor: COLORS.green,
        '&:hover': {
          backgroundColor: COLORS.green,
        }
      },
      contained: {
        height: 40,
        borderRadius: 3,
        color: COLORS.grey,
        backgroundColor: COLORS.white,
        '&:hover': {
          backgroundColor: COLORS.white,
        }
      },
      containedPrimary: {
        background: 'linear-gradient(0deg, rgba(37,97,235,1) 0%, rgba(7,122,235,1) 100%)',
        '&:hover': {
          background: 'linear-gradient(0deg, rgba(37,97,235,1) 0%, rgba(7,122,235,1) 100%)'
        }
      }
    },
    MuiExpansionPanelDetails:{
      root:{
        padding: 0
      }
    },
    MuiExpansionPanel: {
      root: {
        border: '1px solid ' + COLORS.grey,
        boxShadow: 'none',
        borderRadius: 3
      }
    },
    MuiExpansionPanelSummary: {
      // color: 'blue'
      root: {
        background: COLORS.greyFour,
        borderBottom: '1px solid ' + COLORS.grey,
        borderTopRightRadius: 3,
        borderTopLeftRadius: 3,

      }
    },
    MuiFormControl: {
      root: {
        width: '100%',
        // marginBottom: 10
      },
      marginDense:{
        marginBottom: 10,
        marginTop: 0
      }
    },
  }
})



// WEBPACK FOOTER //
// ./src/theme.js